module.exports = __webpack_public_path__ + "img/function02.279591bd.png";